import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _e1625ece = () => interopDefault(import('../../../pages/link/index.vue' /* webpackChunkName: "pages/link/index" */))
const _347f3dc0 = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _424d41ad = () => interopDefault(import('../../../pages/oauth-verification.vue' /* webpackChunkName: "pages/oauth-verification" */))
const _5c7fb918 = () => interopDefault(import('../../../pages/rent/index.vue' /* webpackChunkName: "pages/rent/index" */))
const _ebd848fc = () => interopDefault(import('../../../pages/settings/index.vue' /* webpackChunkName: "pages/settings/index" */))
const _d1a25992 = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _02a90cf2 = () => interopDefault(import('../../../pages/apply/accept-schedule/index.vue' /* webpackChunkName: "pages/apply/accept-schedule/index" */))
const _6515e3d7 = () => interopDefault(import('../../../pages/apply/community-match/index.vue' /* webpackChunkName: "pages/apply/community-match/index" */))
const _a191ea5c = () => interopDefault(import('../../../pages/apply/confirmation.vue' /* webpackChunkName: "pages/apply/confirmation" */))
const _2bafad4c = () => interopDefault(import('../../../pages/apply/features.vue' /* webpackChunkName: "pages/apply/features" */))
const _1addcd28 = () => interopDefault(import('../../../pages/apply/payment-method/index.vue' /* webpackChunkName: "pages/apply/payment-method/index" */))
const _89cc29ec = () => interopDefault(import('../../../pages/apply/pending.vue' /* webpackChunkName: "pages/apply/pending" */))
const _f05e2016 = () => interopDefault(import('../../../pages/apply/rent-info.vue' /* webpackChunkName: "pages/apply/rent-info" */))
const _42acb9fc = () => interopDefault(import('../../../pages/apply/set-schedule/index.vue' /* webpackChunkName: "pages/apply/set-schedule/index" */))
const _70e9e90c = () => interopDefault(import('../../../pages/dev/iframe.vue' /* webpackChunkName: "pages/dev/iframe" */))
const _ddedd60c = () => interopDefault(import('../../../pages/dev/style-guide.vue' /* webpackChunkName: "pages/dev/style-guide" */))
const _dba02984 = () => interopDefault(import('../../../pages/link/confirmation.vue' /* webpackChunkName: "pages/link/confirmation" */))
const _09bfc1f3 = () => interopDefault(import('../../../pages/login/forgot-password.vue' /* webpackChunkName: "pages/login/forgot-password" */))
const _1e7e4cdb = () => interopDefault(import('../../../pages/login/reset-password.vue' /* webpackChunkName: "pages/login/reset-password" */))
const _56ff12be = () => interopDefault(import('../../../pages/match/address.vue' /* webpackChunkName: "pages/match/address" */))
const _41ae409a = () => interopDefault(import('../../../pages/match/community.vue' /* webpackChunkName: "pages/match/community" */))
const _1c826394 = () => interopDefault(import('../../../pages/rent/make-payment/index.vue' /* webpackChunkName: "pages/rent/make-payment/index" */))
const _7eb0219e = () => interopDefault(import('../../../pages/rent/manage-autopay/index.vue' /* webpackChunkName: "pages/rent/manage-autopay/index" */))
const _0e455956 = () => interopDefault(import('../../../pages/rent/payment-history/index.vue' /* webpackChunkName: "pages/rent/payment-history/index" */))
const _3914ab35 = () => interopDefault(import('../../../pages/rent/payment-method/index.vue' /* webpackChunkName: "pages/rent/payment-method/index" */))
const _0fb379f7 = () => interopDefault(import('../../../pages/rent/Payments.vue' /* webpackChunkName: "pages/rent/Payments" */))
const _46aa3e3b = () => interopDefault(import('../../../pages/settings/MFASettings.vue' /* webpackChunkName: "pages/settings/MFASettings" */))
const _0bd353c4 = () => interopDefault(import('../../../pages/signup/activate.vue' /* webpackChunkName: "pages/signup/activate" */))
const _c88b2bb2 = () => interopDefault(import('../../../pages/signup/SignUpForm.vue' /* webpackChunkName: "pages/signup/SignUpForm" */))
const _e3943b80 = () => interopDefault(import('../../../pages/signup/Video.vue' /* webpackChunkName: "pages/signup/Video" */))
const _5484777c = () => interopDefault(import('../../../pages/apply/accept-schedule/Details.vue' /* webpackChunkName: "pages/apply/accept-schedule/Details" */))
const _5ff8cfe7 = () => interopDefault(import('../../../pages/apply/community-match/AddressInfo.vue' /* webpackChunkName: "pages/apply/community-match/AddressInfo" */))
const _60c5a2b3 = () => interopDefault(import('../../../pages/apply/community-match/ErrorModals.vue' /* webpackChunkName: "pages/apply/community-match/ErrorModals" */))
const _7087f39c = () => interopDefault(import('../../../pages/apply/community-match/RentInfo.vue' /* webpackChunkName: "pages/apply/community-match/RentInfo" */))
const _33078061 = () => interopDefault(import('../../../pages/apply/payment-method/ConfirmPaymentMethod.vue' /* webpackChunkName: "pages/apply/payment-method/ConfirmPaymentMethod" */))
const _7f9dea62 = () => interopDefault(import('../../../pages/apply/payment-method/HeaderContent.vue' /* webpackChunkName: "pages/apply/payment-method/HeaderContent" */))
const _eaa700d6 = () => interopDefault(import('../../../pages/apply/set-schedule/ScheduleCalendar.vue' /* webpackChunkName: "pages/apply/set-schedule/ScheduleCalendar" */))
const _ae9cee60 = () => interopDefault(import('../../../pages/apply/set-schedule/SelectFrequency.vue' /* webpackChunkName: "pages/apply/set-schedule/SelectFrequency" */))
const _2d41beb8 = () => interopDefault(import('../../../pages/apply/set-schedule/SelectStartDate.vue' /* webpackChunkName: "pages/apply/set-schedule/SelectStartDate" */))
const _45f00904 = () => interopDefault(import('../../../pages/rent/payments/FundingPaymentsSummary.vue' /* webpackChunkName: "pages/rent/payments/FundingPaymentsSummary" */))
const _1568782a = () => interopDefault(import('../../../pages/rent/payments/PendingPaymentsSummary.vue' /* webpackChunkName: "pages/rent/payments/PendingPaymentsSummary" */))
const _b122c218 = () => interopDefault(import('../../../pages/rent/payments/RepayingPaymentsSummary.vue' /* webpackChunkName: "pages/rent/payments/RepayingPaymentsSummary" */))
const _59122d8a = () => interopDefault(import('../../../pages/rent/payments/ResidentPaidOff.vue' /* webpackChunkName: "pages/rent/payments/ResidentPaidOff" */))
const _25b67232 = () => interopDefault(import('../../../pages/v2/apply/accept-schedule/index.vue' /* webpackChunkName: "pages/v2/apply/accept-schedule/index" */))
const _4f919dcc = () => interopDefault(import('../../../pages/v2/apply/community-match/index.vue' /* webpackChunkName: "pages/v2/apply/community-match/index" */))
const _5ba5593d = () => interopDefault(import('../../../pages/v2/apply/confirmation.vue' /* webpackChunkName: "pages/v2/apply/confirmation" */))
const _743c6545 = () => interopDefault(import('../../../pages/v2/apply/features.vue' /* webpackChunkName: "pages/v2/apply/features" */))
const _4bb88093 = () => interopDefault(import('../../../pages/v2/apply/payment-method/index.vue' /* webpackChunkName: "pages/v2/apply/payment-method/index" */))
const _2ae905bf = () => interopDefault(import('../../../pages/v2/apply/pending.vue' /* webpackChunkName: "pages/v2/apply/pending" */))
const _42e0352d = () => interopDefault(import('../../../pages/v2/apply/set-schedule/index.vue' /* webpackChunkName: "pages/v2/apply/set-schedule/index" */))
const _1032d4f7 = () => interopDefault(import('../../../pages/v2/apply/accept-schedule/Details.vue' /* webpackChunkName: "pages/v2/apply/accept-schedule/Details" */))
const _435c7e1c = () => interopDefault(import('../../../pages/v2/apply/community-match/AddressInfo.vue' /* webpackChunkName: "pages/v2/apply/community-match/AddressInfo" */))
const _442950e8 = () => interopDefault(import('../../../pages/v2/apply/community-match/ErrorModals.vue' /* webpackChunkName: "pages/v2/apply/community-match/ErrorModals" */))
const _482de7c6 = () => interopDefault(import('../../../pages/v2/apply/community-match/RentInfo.vue' /* webpackChunkName: "pages/v2/apply/community-match/RentInfo" */))
const _39082996 = () => interopDefault(import('../../../pages/v2/apply/payment-method/ConfirmPaymentMethod.vue' /* webpackChunkName: "pages/v2/apply/payment-method/ConfirmPaymentMethod" */))
const _08b002cd = () => interopDefault(import('../../../pages/v2/apply/payment-method/HeaderContent.vue' /* webpackChunkName: "pages/v2/apply/payment-method/HeaderContent" */))
const _faa0e376 = () => interopDefault(import('../../../pages/v2/apply/payment-method/LinkBank.vue' /* webpackChunkName: "pages/v2/apply/payment-method/LinkBank" */))
const _0a36dfb8 = () => interopDefault(import('../../../pages/v2/apply/payment-method/LinkBankManually.vue' /* webpackChunkName: "pages/v2/apply/payment-method/LinkBankManually" */))
const _23dd748a = () => interopDefault(import('../../../pages/v2/apply/set-schedule/ScheduleCalendar.vue' /* webpackChunkName: "pages/v2/apply/set-schedule/ScheduleCalendar" */))
const _a9a6476c = () => interopDefault(import('../../../pages/v2/apply/set-schedule/SelectAbleToPayAmount.vue' /* webpackChunkName: "pages/v2/apply/set-schedule/SelectAbleToPayAmount" */))
const _31c3a13b = () => interopDefault(import('../../../pages/v2/apply/set-schedule/SelectFrequency.vue' /* webpackChunkName: "pages/v2/apply/set-schedule/SelectFrequency" */))
const _7271390f = () => interopDefault(import('../../../pages/v2/apply/set-schedule/SelectStartDate.vue' /* webpackChunkName: "pages/v2/apply/set-schedule/SelectStartDate" */))
const _244085e6 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/v/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/link",
    component: _e1625ece,
    name: "link"
  }, {
    path: "/login",
    component: _347f3dc0,
    name: "login"
  }, {
    path: "/oauth-verification",
    component: _424d41ad,
    name: "oauth-verification"
  }, {
    path: "/rent",
    component: _5c7fb918,
    name: "rent"
  }, {
    path: "/settings",
    component: _ebd848fc,
    name: "settings"
  }, {
    path: "/signup",
    component: _d1a25992,
    name: "signup"
  }, {
    path: "/apply/accept-schedule",
    component: _02a90cf2,
    name: "apply-accept-schedule"
  }, {
    path: "/apply/community-match",
    component: _6515e3d7,
    name: "apply-community-match"
  }, {
    path: "/apply/confirmation",
    component: _a191ea5c,
    name: "apply-confirmation"
  }, {
    path: "/apply/features",
    component: _2bafad4c,
    name: "apply-features"
  }, {
    path: "/apply/payment-method",
    component: _1addcd28,
    name: "apply-payment-method"
  }, {
    path: "/apply/pending",
    component: _89cc29ec,
    name: "apply-pending"
  }, {
    path: "/apply/rent-info",
    component: _f05e2016,
    name: "apply-rent-info"
  }, {
    path: "/apply/set-schedule",
    component: _42acb9fc,
    name: "apply-set-schedule"
  }, {
    path: "/dev/iframe",
    component: _70e9e90c,
    name: "dev-iframe"
  }, {
    path: "/dev/style-guide",
    component: _ddedd60c,
    name: "dev-style-guide"
  }, {
    path: "/link/confirmation",
    component: _dba02984,
    name: "link-confirmation"
  }, {
    path: "/login/forgot-password",
    component: _09bfc1f3,
    name: "login-forgot-password"
  }, {
    path: "/login/reset-password",
    component: _1e7e4cdb,
    name: "login-reset-password"
  }, {
    path: "/match/address",
    component: _56ff12be,
    name: "match-address"
  }, {
    path: "/match/community",
    component: _41ae409a,
    name: "match-community"
  }, {
    path: "/rent/make-payment",
    component: _1c826394,
    name: "rent-make-payment"
  }, {
    path: "/rent/manage-autopay",
    component: _7eb0219e,
    name: "rent-manage-autopay"
  }, {
    path: "/rent/payment-history",
    component: _0e455956,
    name: "rent-payment-history"
  }, {
    path: "/rent/payment-method",
    component: _3914ab35,
    name: "rent-payment-method"
  }, {
    path: "/rent/Payments",
    component: _0fb379f7,
    name: "rent-Payments"
  }, {
    path: "/settings/MFASettings",
    component: _46aa3e3b,
    name: "settings-MFASettings"
  }, {
    path: "/signup/activate",
    component: _0bd353c4,
    name: "signup-activate"
  }, {
    path: "/signup/SignUpForm",
    component: _c88b2bb2,
    name: "signup-SignUpForm"
  }, {
    path: "/signup/Video",
    component: _e3943b80,
    name: "signup-Video"
  }, {
    path: "/apply/accept-schedule/Details",
    component: _5484777c,
    name: "apply-accept-schedule-Details"
  }, {
    path: "/apply/community-match/AddressInfo",
    component: _5ff8cfe7,
    name: "apply-community-match-AddressInfo"
  }, {
    path: "/apply/community-match/ErrorModals",
    component: _60c5a2b3,
    name: "apply-community-match-ErrorModals"
  }, {
    path: "/apply/community-match/RentInfo",
    component: _7087f39c,
    name: "apply-community-match-RentInfo"
  }, {
    path: "/apply/payment-method/ConfirmPaymentMethod",
    component: _33078061,
    name: "apply-payment-method-ConfirmPaymentMethod"
  }, {
    path: "/apply/payment-method/HeaderContent",
    component: _7f9dea62,
    name: "apply-payment-method-HeaderContent"
  }, {
    path: "/apply/set-schedule/ScheduleCalendar",
    component: _eaa700d6,
    name: "apply-set-schedule-ScheduleCalendar"
  }, {
    path: "/apply/set-schedule/SelectFrequency",
    component: _ae9cee60,
    name: "apply-set-schedule-SelectFrequency"
  }, {
    path: "/apply/set-schedule/SelectStartDate",
    component: _2d41beb8,
    name: "apply-set-schedule-SelectStartDate"
  }, {
    path: "/rent/payments/FundingPaymentsSummary",
    component: _45f00904,
    name: "rent-payments-FundingPaymentsSummary"
  }, {
    path: "/rent/payments/PendingPaymentsSummary",
    component: _1568782a,
    name: "rent-payments-PendingPaymentsSummary"
  }, {
    path: "/rent/payments/RepayingPaymentsSummary",
    component: _b122c218,
    name: "rent-payments-RepayingPaymentsSummary"
  }, {
    path: "/rent/payments/ResidentPaidOff",
    component: _59122d8a,
    name: "rent-payments-ResidentPaidOff"
  }, {
    path: "/v2/apply/accept-schedule",
    component: _25b67232,
    name: "v2-apply-accept-schedule"
  }, {
    path: "/v2/apply/community-match",
    component: _4f919dcc,
    name: "v2-apply-community-match"
  }, {
    path: "/v2/apply/confirmation",
    component: _5ba5593d,
    name: "v2-apply-confirmation"
  }, {
    path: "/v2/apply/features",
    component: _743c6545,
    name: "v2-apply-features"
  }, {
    path: "/v2/apply/payment-method",
    component: _4bb88093,
    name: "v2-apply-payment-method"
  }, {
    path: "/v2/apply/pending",
    component: _2ae905bf,
    name: "v2-apply-pending"
  }, {
    path: "/v2/apply/set-schedule",
    component: _42e0352d,
    name: "v2-apply-set-schedule"
  }, {
    path: "/v2/apply/accept-schedule/Details",
    component: _1032d4f7,
    name: "v2-apply-accept-schedule-Details"
  }, {
    path: "/v2/apply/community-match/AddressInfo",
    component: _435c7e1c,
    name: "v2-apply-community-match-AddressInfo"
  }, {
    path: "/v2/apply/community-match/ErrorModals",
    component: _442950e8,
    name: "v2-apply-community-match-ErrorModals"
  }, {
    path: "/v2/apply/community-match/RentInfo",
    component: _482de7c6,
    name: "v2-apply-community-match-RentInfo"
  }, {
    path: "/v2/apply/payment-method/ConfirmPaymentMethod",
    component: _39082996,
    name: "v2-apply-payment-method-ConfirmPaymentMethod"
  }, {
    path: "/v2/apply/payment-method/HeaderContent",
    component: _08b002cd,
    name: "v2-apply-payment-method-HeaderContent"
  }, {
    path: "/v2/apply/payment-method/LinkBank",
    component: _faa0e376,
    name: "v2-apply-payment-method-LinkBank"
  }, {
    path: "/v2/apply/payment-method/LinkBankManually",
    component: _0a36dfb8,
    name: "v2-apply-payment-method-LinkBankManually"
  }, {
    path: "/v2/apply/set-schedule/ScheduleCalendar",
    component: _23dd748a,
    name: "v2-apply-set-schedule-ScheduleCalendar"
  }, {
    path: "/v2/apply/set-schedule/SelectAbleToPayAmount",
    component: _a9a6476c,
    name: "v2-apply-set-schedule-SelectAbleToPayAmount"
  }, {
    path: "/v2/apply/set-schedule/SelectFrequency",
    component: _31c3a13b,
    name: "v2-apply-set-schedule-SelectFrequency"
  }, {
    path: "/v2/apply/set-schedule/SelectStartDate",
    component: _7271390f,
    name: "v2-apply-set-schedule-SelectStartDate"
  }, {
    path: "/",
    component: _244085e6,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
